module.exports = __webpack_public_path__ + "img/5.61d73859.jpg";